import {
	ContentContainer,
	ContentBox,
	ContentTitle,
	ContentWrapper
} from './ContentStyled';

import { KeyBox, Key, KeyDesc } from './items/Items';
import { ContentDesctiptionBonus } from './ContentStyled';
import { ReactComponent as UpArrow } from '../assets/symbols/upArrow.svg';
import { ReactComponent as DownArrow } from '../assets/symbols/downArrow.svg';
import { GameConfigs } from '../../lib/globals/GameConfigs';

const KEYS = [
	{
		key: 'A',
		desc: 'Turn On/Off Auto Spin',
		visible: true
	},
	{
		key: 'Space',
		desc: 'Start/Stop Spin',
		visible: true
	},
	{
		key: 'B',
		desc: 'Open/Close Buy Bonus',
		visible: true
	},
	{
		key: 'Q',
		desc: 'Open/Close Quests',
		visible: GameConfigs.hasQuest
	},
	{
		key: 'D',
		desc: 'Turn On/Off Double Chance',
		visible: true
	},
	{
		key: 'S',
		desc: 'Open/Close Settings',
		visible: true
	},
	{
		key: 'I',
		desc: 'Open/Close Info',
		visible: true
	},
	{
		key: 'Esc',
		desc: 'Exit Any Popup',
		visible: true
	},
	{
		key: 'F',
		desc: 'Turn On/Off Fast Spin Mode',
		visible: true
	},
	{
		key: 'arrows',
		desc: 'Change Bet amount',
		visible: true
	},
	{
		key: 'M',
		desc: 'Mute/Unmute Sound Effects',
		visible: true
	}
];

export default function Keyboard({ dimentions }) {
	return (
		<ContentWrapper scale={dimentions.scale}>
			<ContentContainer>
				<div style={{ margin: 'auto' }}>
					<ContentTitle scale={dimentions.scale}>
						KEYBOARD SHORTCUTS
					</ContentTitle>
				</div>
			</ContentContainer>
			<ContentBox style={{ gap: '.8vw 2vw' }}>
				{KEYS.map((item, id) =>
					item.visible ? (
						<KeyBox
							key={id}
							scale={dimentions.scale}
							className={id === 1 ? 'space' : ''}
						>
							{item.key === 'arrows' ? (
								<div className='arrows'>
									<Key scale={dimentions.scale} className='arrow'>
										<span>
											<UpArrow />
										</span>
									</Key>
									<Key scale={dimentions.scale} className='arrow'>
										<span>
											<DownArrow />
										</span>
									</Key>
								</div>
							) : (
								<Key
									scale={dimentions.scale}
									className={id === 1 ? 'space' : ''}
								>
									<span>{item.key}</span>
								</Key>
							)}
							<KeyDesc scale={dimentions.scale}>{item.desc}</KeyDesc>
						</KeyBox>
					) : null
				)}
			</ContentBox>
			<ContentDesctiptionBonus scale={dimentions.scale}>
				Before using hotkeys like the "CAPS," "SHIFT," and "FN" buttons, make
				sure to turn off any functional keys.
			</ContentDesctiptionBonus>
		</ContentWrapper>
	);
}
